import { MutationTree } from 'vuex';
import { LinkToPayState } from './types';

export const mutations: MutationTree<LinkToPayState> = {
  toggleLoading(state, { isLoading = false }): LinkToPayState {
    state.isLoading = isLoading;
    return state;
  },

  setPaymentDetails (state, { payment = null }): LinkToPayState {
    state.payment = payment;
    return state;
  },

  setErrorMessages (state, { errors = [] }): LinkToPayState {
    state.errorMessages = errors;
    return state;
  },

  setPaypalDetails (state, data = null) {
    state.paypalData = data
    return state
  }
};